export default "__VITE_ASSET__b6Ext7bV__"